export function similarity(s1: string, s2: string): any {
    var longer = s1;
    var shorter = s2;

    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }

    const longerLength: any = longer.length;

    if (longerLength === 0) return 1.0;

    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function editDistance(s1: string, s2: string): any {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = [];

    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i === 0) costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) !== s2.charAt(j - 1)) newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0) costs[s2.length] = lastValue;
    }

    return costs[s2.length];
}
